import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase/config';

import VendorWelcome from './components/VendorWelcome';
import AuthScreen from './components/AuthScreen';
import SignUp from './components/SignUp';
import LocationScreen from './components/LocationScreen';
import AvailableProducts from './components/AvailableProducts';
import BestDealInput from './components/BestDealInput';
import VendorDeals from './components/VendorDeals';
import ShopNavigationDetails from './components/ShopNavigationDetails';
import StartNavigationScreen from './components/StartNavigationScreen';
import AddVendors from './scripts/AddVendors';
import Layout from './components/Layout';

import 'leaflet/dist/leaflet.css';

function AppWrapper() {
  const [user, setUser] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        // Convert Firebase user to your app's user object
        const userObj = {
          name: firebaseUser.displayName,
          email: firebaseUser.email,
          photoURL: firebaseUser.photoURL,
          uid: firebaseUser.uid,
        };
        setUser(userObj);
      } else {
        setUser(null);
      }
      setCheckingAuth(false);
    });

    return () => unsubscribe();
  }, []);

  if (checkingAuth) return null; // Optional: add loading screen

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              user ? <Navigate to="/locationscreen" replace /> : <VendorWelcome />
            }
          />
          <Route path="/auth" element={<AuthScreen />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/locationscreen" element={<LocationScreen user={user} />} />
          <Route path="/availableproducts" element={<AvailableProducts />} />
          <Route path="/bestdealinput" element={<BestDealInput />} />
          <Route path="/dealdetails" element={<VendorDeals />} />
          <Route path="/shopnavigationdetails" element={<ShopNavigationDetails />} />
          <Route path="/start-navigation" element={<StartNavigationScreen />} />
          <Route path="/addVendors" element={<AddVendors />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default AppWrapper;
